<template>
  <div>
    <v-date-picker
      class="elevation-0"
      color="blue darken-2"
      landscape
      v-model="date"
      :min="min"
      :max="max"
      full-width
    ></v-date-picker>
    <v-divider />

    <v-time-picker
      landscape
      scrollable
      class="elevation-0 ma-0 pa-0"
      color="blue darken-2"
      v-model="time"
      format="24hr"
      full-width
    ></v-time-picker>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    value: {
      type: String,
    },
    min: {
      type: String,
    },
    max: {
      type: String,
    },
  },

  computed: {
    date: {
      get() {
        return moment(this.$props.value).format('YYYY-MM-DD');
      },
      set(v) {
        const value = moment(`${v} ${this.time}`);
        this.$emit('input', value);
      },
    },

    time: {
      get() {
        return moment(this.$props.value).format('HH:mm');
      },
      set(v) {
        const value = moment(`${this.date} ${v}`);
        this.$emit('input', value);
      },
    },
  },
};
</script>
